// Shared pagination constants: default table page sizes and the named "limit"
// values that recur across list/search endpoints. Used by both the API
// (Prisma `take`/`limit`) and the frontends (data table, member search).
// Dependency-free; safe to import from any package.

/** Default page size for the shared `<DataTable>` / `useDataTable`. */
export const TABLE_PAGE_SIZE = 20;

/** Page size for the VBA member search results. */
export const MEMBER_SEARCH_PAGE_SIZE = 25;

/** Named row caps for endpoints that fetch a bounded "recent" or "top N" slice. */
export const PAGE_SIZE_50 = 50;
export const PAGE_SIZE_100 = 100;

/** Bulk/export caps for endpoints that intentionally pull large result sets. */
export const MAX_EXPORT_ROWS = 500;
export const MAX_BULK_ROWS = 1000;
